import React, { useEffect, memo } from "react";
import api from "../../services/api";
import "./.promocode.css";

const Promocode = ({
  clienteCNPJ,
  setOptionsUsers,
  setOptionsPromoters,
  promoters,
  setPromoters,
  usersPromoter,
  setUsersPromoter,
}) => {
  useEffect(() => {
    const getData = async () => {
      const cnpjRemoveMask = clienteCNPJ;
      const { data } = await api.get(
        `promocode/cliente/${cnpjRemoveMask.replace(/[^0-9]+/g, "")}`
      );

      if (data && data.promocode) {
        const promocode = data.promocode;
        setPromoters({
          IdPromotorConsultor: {
            CNPJ: promocode.IdPromotorConsultor,
            Fantasia: promocode.FantasiaPromotorConsultor,
          },
          IdPromotorFranquia: {
            CNPJ: promocode.IdPromotorFranquia,
            Fantasia: promocode.FantasiaPromotorFranquia,
          },
          IdPromotorContador: {
            CNPJ: promocode.IdPromotorContador,
            Fantasia: promocode.FantasiaPromotorContador,
          },
          IdPromotorEntidade: {
            CNPJ: promocode.IdPromotorEntidade,
            Fantasia: promocode.FantasiaPromotorEntidade,
          },
        });
        setUsersPromoter({
          IdUsuarioConsultor: {
            Id: promocode.IdUsuarioConsultor,
            Nome: promocode.NomeUsuarioConsultor,
          },
          IdUsuarioFranquia: {
            Id: promocode.IdUsuarioFranquia,
            Nome: promocode.NomeUsuarioFranquia,
          },
          IdUsuarioContador: {
            Id: promocode.IdUsuarioContador,
            Nome: promocode.NomeUsuarioContador,
          },
          IdUsuarioEntidade: {
            Id: promocode.IdUsuarioEntidade,
            Nome: promocode.NomeUsuarioEntidade,
          },
        });
      } else {
        setPromoters({
          IdPromotorConsultor: null,
          IdPromotorFranquia: null,
          IdPromotorContador: null,
          IdPromotorEntidade: null,
        });

        setUsersPromoter({
          IdUsuarioConsultor: null,
          IdUsuarioFranquia: null,
          IdUsuarioContador: null,
          IdUsuarioEntidade: null,
        });
      }
    };
    getData();
  }, [clienteCNPJ, setPromoters, setUsersPromoter]);

  useEffect(() => {
    const getData = async () => {
      const { data } = await api.get(`promocode/promotor/usuario`);

      if (data && data.success) {
        setOptionsPromoters(data.data.promoters);
        setOptionsUsers(data.data.users);
      }
    };
    getData();
  }, [clienteCNPJ, setOptionsPromoters, setOptionsUsers]);

  return (
    <div className="containerPromocode">
      <hr className="borderLineTop" />

      <label className="title">Promocode</label>

      <div className="containerRowAdd">
        <div className="textListsPromocodeADM">
          <h6 className="itemPromocode">Consultor</h6>
        </div>

        <div className="textListsPromocodeADM">
          <h6 className="itemPromocode">
            {promoters.IdPromotorConsultor
              ? promoters.IdPromotorConsultor.Fantasia
              : null}
          </h6>
        </div>
        <div className="textListsPromocodeADM">
          <h6 className="itemPromocode">
            {usersPromoter.IdUsuarioConsultor
              ? usersPromoter.IdUsuarioConsultor.Nome
              : null}
          </h6>
        </div>
      </div>
      <hr className="borderLine" />

      <div className="containerRowAdd">
        <div className="textListsPromocodeADM">
          <h6 className="itemPromocode">Franquia</h6>
        </div>

        <div className="textListsPromocodeADM">
          <h6 className="itemPromocode">
            {promoters.IdPromotorFranquia
              ? promoters.IdPromotorFranquia.Fantasia
              : null}
          </h6>
        </div>
        <div className="textListsPromocodeADM">
          <h6 className="itemPromocode">
            {usersPromoter.IdUsuarioFranquia
              ? usersPromoter.IdUsuarioFranquia.Nome
              : null}
          </h6>
        </div>
      </div>
      <hr className="borderLine" />

      <div className="containerRowAdd">
        <div className="textListsPromocodeADM">
          <h6 className="itemPromocode">Contador</h6>
        </div>

        <div className="textListsPromocodeADM">
          <h6 className="itemPromocode">
            {promoters.IdPromotorContador
              ? promoters.IdPromotorContador.Fantasia
              : null}
          </h6>
        </div>
        <div className="textListsPromocodeADM">
          <h6 className="itemPromocode">
            {usersPromoter.IdUsuarioContador
              ? usersPromoter.IdUsuarioContador.Nome
              : null}
          </h6>
        </div>
      </div>
      <hr className="borderLine" />

      <div className="containerRowAdd">
        <div className="textListsPromocodeADM">
          <h6 className="itemPromocode">Entidade</h6>
        </div>

        <div className="textListsPromocodeADM">
          <h6 className="itemPromocode">
            {promoters.IdPromotorEntidade
              ? promoters.IdPromotorEntidade.Fantasia
              : null}
          </h6>
        </div>
        <div className="textListsPromocodeADM">
          <h6 className="itemPromocode">
            {usersPromoter.IdUsuarioEntidade
              ? usersPromoter.IdUsuarioEntidade.Nome
              : null}
          </h6>
        </div>
      </div>
      <hr className="borderLine" />
    </div>
  );
};

export default memo(Promocode);
